const TimelineActions = {
  PROJECT_CREATED: 'Project created',
  CUSTOMER_ADDED: 'Customer added',
  CUSTOMER_REGISTERED: 'Customer registered',
  CUSTOMER_REINVITED: 'Customer reinvited',
  EDITOR_ADDED: 'Editor added',
  EDITOR_UPDATED: 'Editor updated',
  WRITER_ADDED: 'Writer added',
  WRITER_UPDATED: 'Writer updated',
  DEVELOPMENTAL_EDITOR_ADDED: 'Developmental Editor added',
  DEVELOPMENTAL_EDITOR_UPDATED: 'Developmental Editor updated',
  QUESTIONNAIRE_SENT: 'Questionnaire sent to Customer',
  QUESTIONNAIRE_COMPLETED: 'Questionnaire completed',
  INTERVIEW_SCHEDULED: 'Interview scheduled',
  INTERVIEW_COMPLETED: 'Interview completed',
  OUTLINE_SUBMITTED: 'Outline submitted',
  OUTLINE_APPROVED: 'Outline approved',
  SAMPLE_APPROVED: 'Sample approved',
  SAMPLE_SUBMITTED: 'Sample submitted',
  STYLE_SAMPLE_APPROVED: 'Style sample approved',
  DRAFT_SUBMITTED: 'Draft submitted',
  DRAFT_CREATED_BY_CONTENT_TEAM: 'Draft created by Content team',
  DRAFT_PROOFREADING: 'Draft submitted to Developmental Editor',
  DRAFT_PRO_PROOFREADING: 'Draft submitted to Pro Proofreader',
  DRAFT_APPROVED: 'Draft approved',
  DRAFT_COMMENTED: 'First comment has been added',
  DRAFT_SUBMITTED_TO_CUSTOMER: 'Draft submitted to Customer',
  DRAFT_FEEDBACK_SENT: 'Draft feedback sent',
  DRAFT_EDITED_BY_CUSTOMER: 'Customer edited Draft',
  FIRST_PHOTO_UPLOADED: 'First photo uploaded',
  ALL_PHOTOS_UPLOADED: 'All photos are uploaded',
  ALL_PHOTOS_ALLOCATED: 'Photos allocated',
  ADDED_FIRST_CAPTION: 'The first caption is added',
  COVER_SUBMITTED: 'Cover submitted',
  COVER_APPROVED: 'Cover approved',
  PDF_GENERATED: 'PDF generated',
  PROOF_APPROVED: 'Proof approved',
  PROOFREAD_COMPLETED: 'Proofread completed',
  BOOK_SENT_TO_PRINTER: 'Book sent to printer',
  PROJECT_COMPLETED: 'Project completed',
  PROJECT_ARCHIVED: 'Project archived',
  PROJECT_RESTORED: 'Project restored',
  OUTLINE_FEEDBACK_BY_EDITOR: 'Outline feedback sent by Editor',
  OUTLINE_FEEDBACK_BY_CUSTOMER: 'Outline feedback sent by Customer',
  INTERVIEW_NO_SHOW: 'Interview completed (no show)',
  INTERVIEW_CANCELLED: 'Interview cancelled',
  COMPLETE_INTERVIEW_STAGE: 'Interview stage completed',
  PHOTOS_SUBMITTED: 'Photos submitted',
  PROJECT_OVERTAKEN: 'Project overtaken',
  PROJECT_TIMELINE_UPDATED: 'Project timeline is updated',
  WRITER_RATED: 'Writer rated',
  OUTLINE_RATED: 'Outline rated',
  DRAFT_RATED: 'Draft rated',
  ONBOARDING_RATED: 'Onboarding rated',
  PROOF_RATED: 'Proof rated',
  SAMPLE_RATED: 'Sample rated',
  PROJECT_CONVERTED_FROM_PDF: 'Project converted from PDF builder into classic one',
  INTERVIEW_AUDIO_UPLOADED: 'Interview audio uploaded',
  INTERVIEW_TRANSCRIPT_UPLOADED: 'Interview transcript uploaded',
  PACKAGE_UPGRADE_PAID: 'Package upgrade was paid',
  UPGRADE_CANCELED: 'Upgrade was canceled',
  UPGRADE_COMPLETED: 'Upgrade was completed',
  EXTENSION_FEE_PAID: 'Extension fee paid',
  VERSION_RESTORED: 'Version restored',
  CUSTOM_PDF_UPLOADED: 'Custom PDF uploaded',
  CUSTOM_COVER_UPLOADED: 'Custom cover uploaded',
  PROOF_PDF_COMMENTED: 'First comment has been added on Proof',
  PRO_PROOFREADER_ADDED: 'Pro Proofreader added',
  PRO_PROOFREADER_UPDATED: 'Pro Proofreader updated',
};

module.exports = TimelineActions;
